import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import type { RouteObject } from 'react-router-dom';

const LoginPage = Loadable(lazy(() => import('./components/LoginPage')));
const EmailLinkCallbackPage = Loadable(lazy(() => import('./components/EmailLinkCallbackPage')));

/**
 * This feature's own routes, composed into the app router by whichever legacy route file
 * still owns this path prefix — src/routes/LoginRoutes.jsx today (it supplies the
 * GuestGuard + MinimalLayout shell), src/app/router.tsx once that exists (AGENTS.md §1).
 *
 * Pending audit 2026-10-30 (WEB-7): the template's `/register`, `/forgot-password`,
 * `/reset-password`, `/check-mail` and `/code-verification` are gone. Sign-in is Google or the
 * e-mail link (`LoginPage` → `/email-link-signin`), nothing in this repo or the landing linked
 * them, their copy was English, and `/reset-password` never called Firebase. A stale link lands
 * on `AuthenticationRoutes`' `*` → `/`.
 */
export const authRoutes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/email-link-signin',
    element: <EmailLinkCallbackPage />
  }
];
